<template>
  <div>
    <hot-table :settings="settings" ref="tablaCertificados" @openMessageDialog="openMessageDialog" @cargarAsignaturas="cargarAsignaturas"></hot-table>

    <v-dialog v-model="loadingDialog" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>Espera un momento
          <v-progress-linear indeterminate color="white" mb-0></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="messageDialog" persistent width="300">
      <v-card>
        <v-card-title>
          <span class="headline">Datos Obligatorios</span>
        </v-card-title>
        <v-card-text>
          <div class="body-2">
            Entidad Federativa de Expedición<br>
            Nombre del Campus<br>
            Tipo de RVOE<br>
            Nombre de Carrera<br>
            Modalidad<br>
            Clave del Plan<br>
            Tipo de Periodo<br>
            Número de RVOE
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" flat @click="messageDialog = false">Continuar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="saveDialog"
      persistent
      max-width="500px"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Guardar Certificados</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" @submit.prevent="guardarCertificados" lazy-validation v-model="valid">
            <v-autocomplete
              @keyup.enter="$event.target.blur()"
              v-model="form.campus_id"
              :items="auth.campuses"
              item-text="nombre"
              item-value="id"
              :label="labels.campus"
              dense
              hide-no-data
              :error-messages="errors.campus"
              :rules="[rules.required('campus')]"
            ></v-autocomplete>

            <v-select
              :label="labels.tipo_rvoe"
              v-model="form.tipo_rvoe"
              :items="tipo_rvoe"
              :error-messages="errors.tipo_rvoe"
              :rules="[rules.required('tipo_rvoe')]"
              :disabled="loading"
              dense
            ></v-select>

            <v-radio-group v-model="form.tipo_guardado">
              <v-radio
                :label="labels.crear_nuevo_lote"
                value="nuevo"
              ></v-radio>
              <v-radio
                :label="labels.agregar_lote_capturado"
                value="agregar"
              ></v-radio>
            </v-radio-group>

            <v-text-field
              v-if="form.tipo_guardado === 'nuevo'"
              :label="labels.nombre_lote"
              v-model="form.nombre"
              :error-messages="errors.nombre_lote"
              :rules="[rules.required('nombre_lote')]"
            ></v-text-field>

            <v-autocomplete
              v-if="form.tipo_guardado === 'agregar'"
              v-model="form.lote_id"
              :items="lotesCertificadosCapturado"
              :loading="loadingBusqueda"
              :search-input.sync="busquedaCertificados"
              hide-no-data
              item-text="nombre"
              item-value="id"
              :label="labels.nombre_lote"
              return-object
              chips
              dense
              :error-messages="errors.nombre_lote"
              :rules="[rules.required('nombre_lote')]"
            ></v-autocomplete>

            <v-layout justify-end mt-2>
              <v-btn color="primary darken-1" flat @click="closeDialog">Cancelar</v-btn>
              <v-btn color="primary" type="submit">Continuar</v-btn>
            </v-layout>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="erroresDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Resultados del envío de certificados</span>
        </v-card-title>
        <v-card-text>
          <v-data-table
              v-if="erroresCertificados.length"
              :headers="headers"
              :items="erroresCertificados"
              :rows-per-page-items="rowsPerPageItems"
              :rows-per-page-text="rowsPerPageText"
              :pagination.sync="pagination"
            >
              <template slot="items" slot-scope="props">
                <td>{{ props.item.linea }}</td>
                <td>
                  <div
                    v-for="(mensaje, index) in props.item.mensajes"
                    :key="index"
                  >
                    {{ mensaje }}
                  </div>
                </td>
              </template>
            </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat="flat" @click="erroresDialog = false">Continuar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import { api } from '~/config'
  import Form from '~/mixins/form'
  import { HotTable } from '@handsontable/vue'
  import Handsontable from 'handsontable'
  import 'handsontable/languages/es-MX'

  export default {
    mixins: [Form],

    components: {
      HotTable
    },

    data: () => ( {

      loadingBusqueda: false,
      busquedaCertificados: null,
      lotesCertificadosCapturado: [],

      loadingDialog: false,
      messageDialog: false,
      saveDialog: false,
      erroresDialog: false,

      entidades_federativas: [],
      campuses: [],
      programas: [],

      carreras: [],
      planes: [],
      rvoes: [],

      form: {
        campus_id: null,
        nombre: null,
        lote_id: null,
        tipo_guardado: 'nuevo',
        tipo_rvoe: ''
      },

      rowsPerPageItems: [5, 10, 50, 100],
      rowsPerPageText: "Filas por página",

      pagination: {
        rowsPerPage: 10
      },

      headers: [
        { text: "Número de Línea", value: "linea" },
        { text: "Mensaje", value: "mensajes" },
      ],

      erroresCertificados: [],

      tipo_rvoe: ['Federal', 'Estatal'],

      settings: {
        language: 'es-MX',

        data: [
          [],[],[],[],[],
          [],[],[],[],[],
          [],[],[],[],[],
          [],[],[],[],[],
        ],

        colHeaders: [ 'Fecha de Expedición', 'Entidad Federativa de Expedición', 'Nombre del Campus', 'Tipo de RVOE', 'Nombre de Carrera', 'Modalidad', 'Clave del Plan', 'Tipo de Periodo', 'Número de RVOE', 'Matricula del Alumno', 'CURP del Alumno', 'Nombre del Alumno', 'Primer Apellido del Alumno', 'Segundo Apellido del Alumno', 'Capturar Calificaciones' ],

        comments: true,
        rowHeaders: false,
        preventOverflow: 'horizontal',
        manualColumnResize: true,
        renderAllRows: true,

        contextMenu:  {
          items: {
            'row_above': {},
            'row_below': {},
            'separator': Handsontable.plugins.ContextMenu.SEPARATOR,
            'copy': {},
            'cut': {},
            'separator2': Handsontable.plugins.ContextMenu.SEPARATOR,
            'remove_row': {},
          }
        },

        afterChange: function ( change, source ) {

          if ( source === "loadData" ) {
            if ( localStorage[ 'dataCertificados' ] ) {
              let dataCertificados = JSON.parse( localStorage[ 'dataCertificados' ] )
              this.loadData( dataCertificados )
              this.render()
            }

          } else {
            localStorage[ 'dataCertificados' ] = JSON.stringify( this.getData() )
          }

        },

        //afterBeginEditing: function(row, col) {
          //document.activeElement.blur();
        //},

        afterOnCellMouseDown: function ( e, coords, TD ) {

          if ( coords.col === 14 && coords.row >= 0 ) {

            let datos = this.getDataAtRow( coords.row )

            if ( !datos[ 1 ] || !datos[ 2 ] || !datos[ 3 ] || !datos[ 4 ] || !datos[ 5 ] || !datos[ 6 ] || !datos[ 7 ] || datos[ 2 ].length === 0 || datos[ 3 ].length === 0 || datos[ 4 ].length === 0 || datos[ 5 ].length === 0 || datos[ 6 ].length === 0 || datos[ 7 ].length === 0) {
              this.rootElement.__vue__.$emit('openMessageDialog')
              return
            }

            localStorage[ 'dataCertificados' ] = JSON.stringify( this.getData() )

            this.rootElement.__vue__.$router.push( {
              name: 'lotes-certificados-certificados-calificaciones-capturar',
              params: {
                id: coords.row + 1
              }
            } )

          }
        },

        cells: function ( row, col ) {
          const cellProp = {}

          if ( col === 14 ) {
            cellProp.readOnly = true
            cellProp.renderer = function ( instance, td, row, col, prop, value, cellProperties ) {
              td.innerHTML = '<button type="button" class="v-btn v-btn--small v-btn--flat theme--light primary--text" style="margin-top: 0px; margin-bottom: 0px; height: 22px;"><div class="v-btn__content">Capturar</div></button>'
            }
          }

          return cellProp
        },

        columns: [ 
          {
            type: 'date',
            dateFormat: 'YYYY-MM-DD',
            datePickerConfig: {
              i18n: {
                previousMonth: 'Mes Anterior',
                nextMonth: 'Mes Siguiente',
                months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
                weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb']
              },
              maxDate: null
            }
          },
          {
            type: 'dropdown',
          },
          {
            type: 'dropdown',
          },
          {
            type: 'dropdown',
          },
          {
            type: 'dropdown',
          },
          {
            type: 'dropdown',
          },
          {
            type: 'dropdown',
          },
          {
            type: 'dropdown',
          },
          {
            type: 'dropdown',
          },
          {},
          {},
          {},
          {},
          {},
          {}
        ]
      }
    } ),

    computed: {
      ...mapGetters({
        live_mode: "auth/live_mode",
        auth: 'auth/user',
        enviarCertificados: "auth/enviarCertificados",
      })
    },

    watch: {
      live_mode(val) {
        if (val !== undefined) {
          this.$router.push({ name: 'lotes-certificados' })
        }
      },

      enviarCertificados(val) {
        if(val) {
          if (this.auth.campuses.length === 1) {
            this.form.campus_id = this.auth.campuses[0].id
          }
          this.saveDialog = true
        }
      },

      busquedaCertificados (val) {
        console.log(val)
        this.buscarlotesCertificadosCapturado(val)
      }
    },

    mounted() {
      window.addEventListener( 'resize', this.updateTableSize )
      this.getCatalogoCapturarCertificados()
      this.updateTableSize()
    },

    methods: {
       buscarlotesCertificadosCapturado(val) {
        this.loadingBusqueda = true
        axios
          .get(api.path("lotes_certificados"), {
            params: {
              estado: 'capturado',
              q: val
            }
          })
          .then(res => {
            this.lotesCertificadosCapturado = res.data.data
          })
          .catch(err => {
            this.handleRequestError(err)
          })
          .then(() => {
            this.loadingBusqueda = false
          })
      },

      updateTableSize() {
        this.$nextTick(() => {
          if (this.$refs.tablaCertificados && typeof this.$refs.tablaCertificados.hotInstance !== 'undefined') {
            this.$refs.tablaCertificados.hotInstance.updateSettings({
              height: window.innerHeight - 48
            });
          }
        });
      },

      openMessageDialog() {
        this.messageDialog = true
      },

      closeDialog() {
        this.saveDialog = false
        this.$store.dispatch('auth/guardarEnviarCertificados', { enviarCertificados: false })
      },

      // err.response solo existe si el servidor respondió con un error HTTP.
      // Si el fallo fue de JavaScript (p. ej. programas[0] undefined) se muestra en consola.
      handleRequestError(err) {
        if (err && err.response && err.response.data) {
          this.handleErrors(err.response.data.errors)
        } else {
          console.error(err)
        }
      },

      cargarAsignaturas: function (busqueda, row) {
        axios
          .get( api.path( 'programas'), {
            params: {
              page_size: 1,
              q: busqueda
            }  
          })
          .then( res => {
            if(res.data.data && res.data.data.length > 0) {
              let programas = res.data.data

              axios
                .get(api.path('programas.asignaturas', { id: programas[0].id } ))
                .then(res => {
                    if(res.data.data) {
                      let asignaturas = []

                      res.data.data.forEach(function(asignatura) {
                        asignaturas.push([
                          asignatura.nombre,
                          asignatura.clave,
                          null,
                          null,
                          null,
                        ])
                      });

                      let diferentesAsignaturas = false

                      if(localStorage[ 'dataCalificaciones[' + (row + 1) + ']' ]) {
                        let dataCalificaciones = JSON.parse( localStorage[ 'dataCalificaciones[' + (row + 1) + ']' ] )

                        if(dataCalificaciones) {
                          dataCalificaciones.forEach(function(calificacion, index) {
                            if(!diferentesAsignaturas) {
                              if(!asignaturas[index] || !calificacion || !(asignaturas[index][0] === calificacion[0] && asignaturas[index][1] === calificacion[1])) {
                                diferentesAsignaturas = true
                              }
                            }
                          });
                        } else {
                          diferentesAsignaturas = true
                        }
                      } else {
                        diferentesAsignaturas = true
                      }

                      if(diferentesAsignaturas) {
                        localStorage[ 'dataCalificaciones[' + (row + 1) + ']' ] = JSON.stringify( asignaturas )
                      }
                    }
                })
                .catch(err => {
                  this.handleRequestError(err)
                })
                .then(() => {
                })
            }
          } )
          .catch( err => {
            this.handleRequestError(err)
          } )
          .then( () => {} )
      },

      guardarCertificados() {

        if (this.$refs.form.validate()) {
          this.closeDialog()

          let dataCertificados = this.$refs.tablaCertificados.hotInstance.getData()

          if (dataCertificados.length === 0) {
            return
          }

          localStorage[ 'dataCertificados' ] = JSON.stringify( dataCertificados )

          this.loadingDialog = true

          let calificaciones = []

          for (let i = 0; i < dataCertificados.length; i++) {
            if (localStorage[ 'dataCalificaciones[' + (i + 1) + ']' ]) {
              let dataCalificaciones = JSON.parse( localStorage[ 'dataCalificaciones[' + (i + 1) + ']' ] )
              
              calificaciones.push( dataCalificaciones )
            } else {
              calificaciones.push( [] )
            }
          }

          axios
            .put( api.path( 'lotes_certificados' ), {
              nombre: this.form.nombre,
              campus_id: this.form.campus_id,
              lote_id: this.form.lote_id,
              tipo_guardado: this.form.tipo_guardado,
              tipo_rvoe: this.form.tipo_rvoe,
              certificados: dataCertificados,
              calificaciones: calificaciones,
            } )
            .then( res => {
              if(res.data.errores) {
                this.erroresCertificados = res.data.errores
                this.erroresDialog = true;
              } else {
                if(res.data.id) {
                  this.$toast.success( 'Certificados guardados correctamente.' )
                
                  for (let i = 0; i < dataCertificados.length; i++) {
                    localStorage.removeItem('dataCalificaciones[' + i + ']');
                  }

                  localStorage.removeItem('dataCertificados');

                  this.$router.go(-1)
                }
              }
            } )
            .catch( err => {
              this.loadingDialog = false
              this.$toast.error('No se pueden enviar los certificados.')
              this.handleRequestError(err)
            } )
            .then( () => {
              this.loadingDialog = false
            } )
        }
      },

      getCatalogoCapturarCertificados() {
        axios
          .get(api.path('catalogos.capturar_certificados'))
          .then(res => {
            this.entidades_federativas = res.data.entidades_federativas
            this.campuses = res.data.campuses
            this.programas = res.data.programas_federales

            this.$refs.tablaCertificados.hotInstance.updateSettings( {

              afterChange: function ( change, source ) {
                
                // Handsontable llama a afterChange con change === null (p. ej. loadData)
                if ( !change || !change.length ) return

                let row = change[ 0 ][ 0 ]
                let col = change[ 0 ][ 1 ]
                let nuevo = change[ 0 ][ 3 ]

                if ( col === 2 ) {
                  this.setDataAtCell( row, 3, null )
                  this.setDataAtCell( row, 4, null )
                  this.setDataAtCell( row, 5, null )
                  this.setDataAtCell( row, 6, null )
                  this.setDataAtCell( row, 7, null )
                  this.setDataAtCell( row, 8, null )
                  this.render()
                }

                if ( col === 3 ) {
                  this.setDataAtCell( row, 4, null )
                  this.setDataAtCell( row, 5, null )
                  this.setDataAtCell( row, 6, null )
                  this.setDataAtCell( row, 7, null )
                  this.setDataAtCell( row, 8, null )

                  console.log('nuevo=', nuevo)

                  let index_campus = res.data.campuses.indexOf( this.getDataAtCell( row, 2 ) )

                  console.log('index_campus=', index_campus)

                  let carreras = []

                  if ( index_campus >= 0 && nuevo ) {
                    if ( nuevo === 'Federal' ) {
                      carreras = res.data.programas_federales[ index_campus ].carreras
                    } else if ( nuevo === 'Estatal' ) {
                      carreras = res.data.programas_estatales[ index_campus ].carreras
                    }

                    console.log('carreras=', carreras)

                    this.setCellMeta( row, 4, 'source', carreras )
                    if(carreras.length > 1) {
                      this.setDataAtCell( row, 4, null )
                      this.setDataAtCell( row, 5, null )
                      this.setDataAtCell( row, 6, null )
                      this.setDataAtCell( row, 7, null )
                      this.setDataAtCell( row, 8, null )
                    } else if ( carreras.length === 1 ) {
                      this.setDataAtCell( row, 4, carreras[0] )
                    }
                    this.render()
                  }
                }

                if ( col === 4 ) {
                  let index_campus = res.data.campuses.indexOf( this.getDataAtCell( row, 2 ) )
                  let tipo_rvoe = this.getDataAtCell( row, 3 )

                  console.log('tipo_rvoe=', tipo_rvoe)

                  if ( index_campus >= 0 && tipo_rvoe ) {

                    let programas = null

                    if ( tipo_rvoe === 'Federal' ) {
                      programas = res.data.programas_federales[ index_campus ]
                    } else if ( tipo_rvoe === 'Estatal' ) {
                      programas = res.data.programas_estatales[ index_campus ]
                    }

                    console.log('programas=', programas)

                    let index_carrera = programas ? programas.carreras.indexOf( nuevo ) : -1
                    
                    if (index_carrera >= 0) {
                      this.setCellMeta( row, 5, 'source', programas.modalidades[ index_carrera ] )
                      this.setDataAtCell( row, 5, programas.modalidades[ index_carrera ][ 0 ] )
                      this.render()
                    }
                  }
                }
                
                if ( col === 5 ) {
                  let index_campus = res.data.campuses.indexOf( this.getDataAtCell( row, 2 ) )
                  let tipo_rvoe = this.getDataAtCell( row, 3 )

                  console.log('tipo_rvoe=', tipo_rvoe)

                  if ( index_campus >= 0 && tipo_rvoe ) {

                    let programas = null

                    if ( tipo_rvoe === 'Federal' ) {
                      programas = res.data.programas_federales[ index_campus ]
                    } else if ( tipo_rvoe === 'Estatal' ) {
                      programas = res.data.programas_estatales[ index_campus ]
                    }

                    console.log('programas=', programas)

                    let index_carrera = programas ? programas.carreras.indexOf( this.getDataAtCell( row, 4 ) ) : -1

                    if (index_carrera >= 0) {
                      let index_modalidad = programas.modalidades[ index_carrera ].indexOf( nuevo )

                      if ( index_modalidad >= 0 ) {
                        this.setCellMeta( row, 6, 'source', programas.claves_plan[ index_carrera ][ index_modalidad ] )
                        this.setDataAtCell( row, 6, programas.claves_plan[ index_carrera ][ index_modalidad ][ 0 ] )
                        this.render()
                      }
                    }
                  }
                }

                if ( col === 6 ) {
                  let index_campus = res.data.campuses.indexOf( this.getDataAtCell( row, 2 ) )
                  let tipo_rvoe = this.getDataAtCell( row, 3 )

                  console.log('tipo_rvoe=', tipo_rvoe)

                  if ( index_campus >= 0 && tipo_rvoe ) {

                    let programas = null

                    if ( tipo_rvoe === 'Federal' ) {
                      programas = res.data.programas_federales[ index_campus ]
                    } else if ( tipo_rvoe === 'Estatal' ) {
                      programas = res.data.programas_estatales[ index_campus ]
                    }

                    console.log('programas=', programas)

                    let index_carrera = programas ? programas.carreras.indexOf( this.getDataAtCell( row, 4 ) ) : -1

                    if (index_carrera >= 0) {
                      let index_modalidad = programas.modalidades[ index_carrera ].indexOf( this.getDataAtCell( row, 5 ) )

                      if ( index_modalidad >= 0 ) {
                        let index_clave_plan = programas.claves_plan[ index_carrera ][ index_modalidad ].indexOf( nuevo )

                        if ( index_clave_plan >= 0 ) {
                          this.setCellMeta( row, 7, 'source', programas.tipos_periodo[ index_carrera ][ index_modalidad ][ index_clave_plan ] )
                          this.setDataAtCell( row, 7, programas.tipos_periodo[ index_carrera ][ index_modalidad ][ index_clave_plan ][ 0 ] )
                          this.render()
                        }
                      }
                    }
                  }
                }

                if ( col === 7 ) {
                  let index_campus = res.data.campuses.indexOf( this.getDataAtCell( row, 2 ) )
                   let tipo_rvoe = this.getDataAtCell( row, 3 )

                  console.log('tipo_rvoe=', tipo_rvoe)

                  if ( index_campus >= 0 && tipo_rvoe ) {

                    let programas = null

                    if ( tipo_rvoe === 'Federal' ) {
                      programas = res.data.programas_federales[ index_campus ]
                    } else if ( tipo_rvoe === 'Estatal' ) {
                      programas = res.data.programas_estatales[ index_campus ]
                    }

                    console.log('programas=', programas)

                    let index_carrera = programas ? programas.carreras.indexOf( this.getDataAtCell( row, 4 ) ) : -1

                    if (index_carrera >= 0) {
                      let index_modalidad = programas.modalidades[ index_carrera ].indexOf( this.getDataAtCell( row, 5 ) )

                      if ( index_modalidad >= 0 ) {
                        let index_clave_plan = programas.claves_plan[ index_carrera ][ index_modalidad ].indexOf( this.getDataAtCell( row, 6 ) )

                        if ( index_clave_plan >= 0 ) {
                          let index_tipo_periodo = programas.tipos_periodo[ index_carrera ][ index_modalidad ][ index_clave_plan ].indexOf( nuevo )

                          if ( index_tipo_periodo >= 0 ) {
                            this.setCellMeta( row, 8, 'source', programas.numeros_rvoe[ index_carrera ][ index_modalidad ][ index_clave_plan ][ index_tipo_periodo ] )
                            this.setDataAtCell( row, 8, programas.numeros_rvoe[ index_carrera ][ index_modalidad ][ index_clave_plan ][ index_tipo_periodo ][ 0 ] )
                            this.render()
                          }
                        }
                      }
                    }
                  }
                }

                if ( col === 8 ) {
                  let me = this

                  let datos = me.getDataAtRow( row )

                  if(datos[ 2 ] && datos[ 3 ] && datos[ 4 ] && datos[ 5 ] && datos[ 6 ] && datos[ 7 ] && datos[ 8 ] && datos[ 2 ].length > 0 && datos[ 3 ].length > 0 && datos[ 4 ].length > 0 && datos[ 5 ].length > 0 && datos[ 6 ].length > 0 && datos[ 7 ].length > 0 && datos[ 8 ].length > 0) {
                    let busqueda = 'campuses:(' + datos[2] + ') tipos_revoe:(' + datos[3] + ') carreras:(' + datos[4] + ') modalidades:(' + datos[5] + ') clave_plan:(' + datos[6] + ') tipos_periodo:(' + datos[7] + ') numero_rvoe:(' + datos[8] + ')'
                    
                    me.rootElement.__vue__.$emit('cargarAsignaturas', busqueda, row)

                    console.log('prueba (:')
                  }
                }

                if ( source === 'CopyPaste.paste' ) {
                  let filas = []
                  let me = this

                  change.forEach(function(celda) {
                    let row = celda[0]
                    if (filas.indexOf(row) === -1) {
                      filas.push(row)

                      let datos = me.getDataAtRow( row )

                      if(datos[ 2 ] && datos[ 3 ] && datos[ 4 ] && datos[ 5 ] && datos[ 6 ] && datos[ 7 ] && datos[ 2 ].length > 0 && datos[ 3 ].length > 0 && datos[ 4 ].length > 0 && datos[ 5 ].length > 0 && datos[ 6 ].length > 0 && datos[ 7 ].length > 0) {
                        let busqueda = 'campuses:(' + datos[2] + ') carreras:(' + datos[3] + ') modalidades:(' + datos[4] + ') clave_plan:(' + datos[5] + ') tipos_periodo:(' + datos[6] + ') numero_rvoe:(' + datos[7] + ')'
                        
                        me.rootElement.__vue__.$emit('cargarAsignaturas', busqueda, row)
                      }
                    }
                  })

                  localStorage[ 'dataCertificados' ] = JSON.stringify( this.getData() )
                }
              },

              cells: function ( row, col ) {
                const cellProp = {}

                if ( col === 1 ) {
                  cellProp.type = 'dropdown';
                  cellProp.source = res.data.entidades_federativas
                } else if ( col === 2 ) {
                  cellProp.type = 'dropdown';
                  cellProp.source = res.data.campuses
                } else if ( col === 3 ) {
                  cellProp.type = 'dropdown';
                  cellProp.source = ['Federal', 'Estatal']
                } else if ( col === 14 ) {
                  cellProp.readOnly = true
                  cellProp.renderer = function ( instance, td, row, col, prop, value, cellProperties ) {
                    td.innerHTML = '<button type="button" class="v-btn v-btn--small v-btn--flat theme--light primary--text" style="margin-top: 0px; margin-bottom: 0px; height: 22px;"><div class="v-btn__content">Capturar</div></button>'
                  }
                }

                return cellProp
              },
            })
          })
          .catch( err => {
            this.handleRequestError(err)
          })
          .then(() => {
          })
      },
    }
  }
</script>

<style src="~/../node_modules/handsontable/dist/handsontable.full.css"></style>

<style>
th {
  font-family: 'Roboto' !important;
  font-weight: bold !important;
  font-size: 12px !important;
  background-color: white !important;
}
</style>
